import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { IconColorItem } from "./IconColorItem";

import actions from "@/actions";
import { SubmitButton } from "@/components/common";
import { RootState } from "@/reducers/types";
import { Header } from "@/sx-layout/common/Header";
import { ConfirmModal } from "@/sx-layout/common/Modal";
import { useModal } from "@/sx-layout/components/plotmap/hooks";
import { useMachineIconSetting } from "@/sx-layout/components/settings/iconColorSetting/useMachineIconSetting";

export const IconColorSetting = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const machineIcons = useSelector((state: RootState) => state.layoutApp.layoutMasters?.machine_icons);

  const iconSettings = useMachineIconSetting(machineIcons);

  const handleChange = (iconId: number, color?: string) => {
    if (color) {
      iconSettings.add({ id: iconId, color });
    } else {
      iconSettings.remove(iconId);
    }
  };

  const confirmModal = useModal();
  const handleSubmit = () => {
    dispatch(
      actions.layoutMasters.updateLayoutMachineIconSetting(iconSettings.values, () => {
        dispatch(actions.layoutMasters.fetchLayoutMasters());
        confirmModal.open();
      })
    );
  };

  return (
    <div className="bg-[#f3f2ef] min-h-screen">
      <Header />
      <div className="px-[32px]">
        <div className="flex items-center space-x-8">
          <h2 className="my-[16px] font-bold text-[16px]">{t("icon_color_settings")}</h2>
        </div>
        <h3 className="my-[14px] font-bold text-[14px]">{t("icon_color_settings_description")}</h3>
        <div className="bg-[#fff] px-10 py-5 w-[1000px] flex flex-col gap-[20px]">
          {/* アイコンは6つ固定 */}
          {[1, 2, 3, 4, 5, 6].map((iconId) => {
            const iconSetting = iconSettings.values.find((v) => v.machine_icon_id === iconId);

            return (
              <IconColorItem
                key={iconId}
                iconId={iconId}
                iconSetting={iconSetting}
                onChange={(color) => handleChange(iconId, color)}
              />
            );
          })}
        </div>
      </div>
      <div className="px-[32px] py-[24px]">
        <SubmitButton onClick={handleSubmit} />
      </div>
      {confirmModal.isOpen && (
        <ConfirmModal title={t("confirmation")} message={t("save_done")} onClose={confirmModal.close} />
      )}
    </div>
  );
};
